import React from 'react';

import { Box, Divider } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useCompanyOptions from './hooks/useCompanyOptions';
import useIntegrationsOptions from './hooks/useIntegrationsOptions';
import useOperativeOptions from './hooks/useOperativeOptions';
import SubMenuOptions from './SubMenuOptions';

const ConfigurationOptions = ({ handleClose }) => {
    const { t } = useTranslation();
    const companyOptions = useCompanyOptions();
    const integrationsOptions = useIntegrationsOptions();
    const operativeOptions = useOperativeOptions();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <SubMenuOptions
                handleClose={handleClose}
                options={operativeOptions}
                title={t('Operative')}
            />

            <Divider />

            <SubMenuOptions
                handleClose={handleClose}
                options={companyOptions}
                title={t('Company')}
            />

            <Divider />

            <SubMenuOptions
                handleClose={handleClose}
                options={integrationsOptions}
                title={t('Integration', { count: 2 })}
            />
        </Box>
    );
};

ConfigurationOptions.propTypes = {
    handleClose: PropTypes.func,
};

export default ConfigurationOptions;
